module.exports = __webpack_public_path__ + "img/beach.c0a0b0f2.jpg";